module.exports = __webpack_public_path__ + "static/media/leg-right-front.d5a22709.png";